import React from "react";
import { Modal } from "antd";
import { AuthService } from "services";
import { AUTH_STATUS } from "constants";
import PropTypes from "prop-types";
import ProgcapIcon from "assets/progcapLogo.png";

const AuthorizationModal = props => (
    <Modal
        visible={props.modalVisible}
        closable={false}
        maskClosable={false}
        footer={null}
        centered={true}>
        <React.Fragment>
            <img src={ProgcapIcon} alt="" width={50} />
            <div className={"p-5 d-inline"}>{props.modalContent}</div>
        </React.Fragment>
    </Modal>
);

AuthorizationModal.propTypes = {
    modalVisible: PropTypes.bool,
    modalContent: PropTypes.string,
    history: PropTypes.object
};

export default WrappedComponent =>
    class extends React.Component {
        state = {
            modalVisible: false,
            modalButtonText: "",
            modalContent: "",
            authStatus: AuthService.getState()
        };
        componentDidMount() {
            AuthService.onStatusChange(authStatus => {
                const modalState = {
                    modalVisible: false,
                    modalButtonText: "",
                    modalContent: "",
                    authStatus
                };
                switch (authStatus) {
                case AUTH_STATUS.AUTHORIZED:
                    break;
                case AUTH_STATUS.UNAUTHORIZED:
                    modalState.modalVisible = true;
                    modalState.modalContent = "UnAuthorized Session";
                    modalState.modalButtonText = null;
                    break;
                case AUTH_STATUS.VALIDATING_AUTHORIZATION_CREDENTIALS:
                    modalState.modalVisible = true;
                    modalState.modalContent = "Validating";
                    modalState.modalButtonText = null;
                    break;
                case AUTH_STATUS.INVALID_AUTHORIZATION_CREDENTIALS:
                    modalState.modalVisible = true;
                    modalState.modalContent = "Redirecting to Login Page";
                    modalState.modalButtonText = null;
                    break;
                case AUTH_STATUS.REFRESHING_AUTHORIZATION_CREDENTIALS:
                case AUTH_STATUS.REFRESHING_AUTHORIZATION_CREDENTIALS_FAILED:
                default:
                }
                this.setState(
                    {
                        ...modalState
                    },
                    () => {
                        if (
                            this.state.modalContent ===
                            "Redirecting to Login Page"
                        ) {
                            let timedRedirection = setTimeout(() => {
                                this.props.history.replace("/auth");
                                clearTimeout(timedRedirection);
                            }, 2000);
                        }
                    }
                );
            });
        }
        componentWillUnmount() {}
        render() {
            const { props } = this;
            return (
                <React.Fragment>
                    <AuthorizationModal {...this.state} />
                    <WrappedComponent
                        {...props}
                        isAuthenticated={AuthService.isAuthenticated()}
                    />
                </React.Fragment>
            );
        }
        static propTypes = {
            history: PropTypes.object
        };
        static displayName = "AuthConnect";
    };
